module.exports = __webpack_public_path__ + "img/weather_app.5ac61b27.png";